import React, { Component, Fragment } from "react";
import { Card } from "antd";
import SurveyStepSimulationContainer from "./../SurveyStepSimulation";

class Summary extends Component {
	render() {
		return (
			<Fragment>
				<SurveyStepSimulationContainer steps={[]} />
			</Fragment>
		);
	}
}

export default Summary;



// WEBPACK FOOTER //
// src/components/survey/create/Summary/Summary.js